import { useBaseApiQuery } from "@query/baseQuery";

export const useRoleQuery = () => {
    return useBaseApiQuery({ endpoint: "/account/me/role" });
};

export const useAllAdminRolesQuery = () => {
    return useBaseApiQuery({endpoint: "/role/all/admin"});
}